import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import OportunidadesCreate from "./OportunidadesCreate";
import axios from "axios";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import { puede } from "../../../../permisos/permisos";
import { etiquetasEtapas } from "../etapas";

function PipelineKanban() {
  const { user } = useContext(AuthContext);
  const URL_CRM_OPORTUNIDADES = process.env.REACT_APP_URL_CRM_OPORTUNIDADES;
  const URL_CRM_ETAPAS = process.env.REACT_APP_URL_CRM_ETAPAS;
  const URL_CRM_CATEGORIAS = process.env.REACT_APP_URL_CRM_CATEGORIAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [etapas, setEtapas] = useState([]);
  const [oportunidades, setOportunidades] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [filtroCategoria, setFiltroCategoria] = useState("");

  const [modalCreate, setModalCreate] = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);

  const [modalEtapa, setModalEtapa] = useState(false);
  const toggleEtapa = () => setModalEtapa(!modalEtapa);
  const [opSel, setOpSel] = useState(null);
  const [nuevaEtapa, setNuevaEtapa] = useState("");
  const [comentario, setComentario] = useState("");
  const [motivoPerdida, setMotivoPerdida] = useState("");
  const [fechaProxima, setFechaProxima] = useState("");

  useEffect(() => {
    const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    axios
      .get(URL_CRM_ETAPAS, headers)
      .then((r) => setEtapas(r.data.sort((a, b) => (a.orden > b.orden ? 1 : -1))))
      .catch((e) => console.log(e));
    axios
      .get(`${URL_CRM_OPORTUNIDADES}Abiertas`, headers)
      .then((r) => setOportunidades(r.data))
      .catch((e) => console.log(e));
    axios
      .get(URL_CRM_CATEGORIAS, headers)
      .then((r) => setCategorias(r.data))
      .catch((e) => console.log(e));
  }, []);

  function abreCambioEtapa(op) {
    if (!puede(user, "crm.embudo.mover")) return; // sin permiso solo puede consultar
    setOpSel(op);
    setNuevaEtapa(op.etapa ? op.etapa._id : "");
    setComentario("");
    setMotivoPerdida("");
    setFechaProxima(op.fecha_proxima_accion || "");
    toggleEtapa();
  }

  const etapaSelObj = etapas.find((e) => e._id === nuevaEtapa);
  const esPerdida = etapaSelObj && etapaSelObj.tipo === "perdida";

  function guardarCambioEtapa() {
    if (!nuevaEtapa) {
      Swal.fire("Atencion", "Selecciona una etapa", "warning");
      return;
    }
    if (esPerdida && !motivoPerdida) {
      Swal.fire("Atencion", "Indica el motivo de perdida", "warning");
      return;
    }
    const hoy = new Date().toISOString().split("T")[0];
    axios
      .patch(
        `${URL_CRM_OPORTUNIDADES}Etapa/${opSel._id}`,
        {
          etapa: nuevaEtapa,
          usuario: user.id,
          usuarioNombre: user.nombre,
          comentario,
          fecha_proxima_accion: fechaProxima,
          fecha: hoy,
          motivo_perdida: motivoPerdida,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Cambiar Etapa Oportunidad", detalle: opSel.titulo, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        toggleEtapa();
        Swal.fire("Listo!", "Etapa actualizada", "success");
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response ? error.response.data.message || error.response.data : error}`,
        });
      });
  }

  const opsPorEtapa = (etapaId) =>
    oportunidades.filter(
      (o) =>
        o.etapa &&
        o.etapa._id === etapaId &&
        (!filtroCategoria ||
          (o.categorias || []).some((c) => (c._id || c) === filtroCategoria))
    );

  const totalEtapa = (etapaId) =>
    opsPorEtapa(etapaId).reduce((acc, o) => acc + Number(o.valor_estimado || 0), 0);

  const etapasAbiertas = etapas.filter((e) => e.tipo === "abierta");
  const etiquetaEtapa = etiquetasEtapas(etapas);

  return (
    <>
      <Header />
      <br />
      <div className="container-fluid">
        {puede(user, "crm.embudo.ver") ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-stream" style={{ marginRight: 8, color: "#8b5cf6" }} />
                  Embudo Ventas
                </h3>
                <p className="page-subtitle">Embudo de ventas (oportunidades abiertas)</p>
              </div>
              <div className="page-actions" style={{ minWidth: 200 }}>
                <Input type="select" bsSize="sm" value={filtroCategoria} onChange={(e) => setFiltroCategoria(e.target.value)}>
                  <option value="">Todas las categorías</option>
                  {categorias.map((c) => (
                    <option key={c._id} value={c._id}>{c.nombre}</option>
                  ))}
                </Input>
              </div>
            </div>

            {etapasAbiertas.length === 0 ? (
              <p style={{ padding: 16 }}>
                No hay etapas configuradas. Ve a <b>Etapas</b> y carga el pipeline por defecto.
              </p>
            ) : (
              <div style={{ display: "flex", gap: 12, overflowX: "auto", paddingBottom: 12 }}>
                {etapasAbiertas.map((et) => (
                  <div
                    key={et._id}
                    style={{
                      minWidth: 260,
                      flex: "0 0 260px",
                      background: "#f6f7fb",
                      borderRadius: 10,
                      padding: 8,
                    }}
                  >
                    <div
                      style={{
                        borderTop: `4px solid ${et.color}`,
                        borderRadius: 6,
                        background: "#fff",
                        padding: "8px 10px",
                        marginBottom: 8,
                      }}
                    >
                      <div style={{ fontWeight: 600, fontSize: "0.85rem" }}>{etiquetaEtapa[et._id]}</div>
                      <div style={{ fontSize: "0.72rem", color: "#6b7280" }}>
                        {opsPorEtapa(et._id).length} deals · $
                        {totalEtapa(et._id).toLocaleString("es-MX")}
                      </div>
                    </div>

                    {opsPorEtapa(et._id).map((o) => (
                      <div
                        key={o._id}
                        onClick={() => abreCambioEtapa(o)}
                        style={{
                          background: "#fff",
                          borderRadius: 8,
                          padding: 10,
                          marginBottom: 8,
                          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                          cursor: "pointer",
                        }}
                      >
                        <div style={{ fontWeight: 600, fontSize: "0.82rem" }}>{o.titulo}</div>
                        <div style={{ fontSize: "0.74rem", color: "#6b7280" }}>
                          {o.prospecto ? o.prospecto.razon_social : ""}
                        </div>
                        <div style={{ fontSize: "0.78rem", marginTop: 4 }}>
                          <b>${Number(o.valor_estimado || 0).toLocaleString("es-MX")}</b>
                          <span style={{ float: "right", color: "#6b7280" }}>{o.probabilidad}%</span>
                        </div>
                        {o.responsable && (
                          <div style={{ fontSize: "0.7rem", color: "#8b5cf6", marginTop: 3 }}>
                            <i className="fas fa-user" style={{ marginRight: 4 }} />
                            {o.responsable.nombre} {o.responsable.apellido || ""}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : undefined}
      </div>

      {/* Alta */}
      <Modal size="lg" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <i className="fas fa-plus" style={{ marginRight: 8, color: "#8b5cf6" }} />
          Nueva Oportunidad
        </ModalHeader>
        <ModalBody>
          <OportunidadesCreate />
        </ModalBody>
      </Modal>

      {/* Cambiar etapa */}
      <Modal size="md" isOpen={modalEtapa} toggle={toggleEtapa}>
        <ModalHeader toggle={toggleEtapa}>
          <i className="fas fa-exchange-alt" style={{ marginRight: 8, color: "#8b5cf6" }} />
          {opSel ? opSel.titulo : "Mover de etapa"}
        </ModalHeader>
        <ModalBody>
          <Label>Etapa</Label>
          <Input type="select" value={nuevaEtapa} onChange={(e) => setNuevaEtapa(e.target.value)}>
            <option value="">Selecciona...</option>
            {etapas.map((et) => (
              <option key={et._id} value={et._id}>
                {etiquetaEtapa[et._id]}
              </option>
            ))}
          </Input>
          <br />
          <Label>Fecha siguiente reunión</Label>
          <Input type="date" value={fechaProxima} onChange={(e) => setFechaProxima(e.target.value)} />
          <br />
          <Label>Comentario</Label>
          <Input type="textarea" value={comentario} onChange={(e) => setComentario(e.target.value)} />
          {esPerdida && (
            <>
              <br />
              <Label style={{ color: "#dc3545" }}>Motivo de perdida *</Label>
              <Input
                type="text"
                value={motivoPerdida}
                onChange={(e) => setMotivoPerdida(e.target.value)}
              />
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardarCambioEtapa}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default PipelineKanban;
